import noop from 'utils/noop';

export const promptReview = noop;
